import { useFormatMessage } from '../../../intl/intl';

export function usePendingToDeliverColumnLang() {
  const title = useFormatMessage({ id: 'pendingToDeliverColumn.title' });
  const noOrders = useFormatMessage({ id: 'pendingToDeliverColumn.emptyText' });

  return {
    title,
    noOrders,
  };
}
